export const gen = (function* () {
    let i = 0;
    while (true) {
        if (i === Number.MAX_SAFE_INTEGER - 1) {
            i = 0;
        }
        yield i++;
    }
})();
